<template>
  <div>
    <div class="container pt-0">
      <div class="row">
        <div class="col text-center">
          <h1 class="fs-40">{{ $t("heading_confirmation_needed") }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="pane">
            <div class="row">
              <div class="col-12">
                <div class="text-center">
                  <div
                    class="fs-40 mt-5 text-primary"
                  >
                    <font-awesome-icon icon="hourglass-start" />
                  </div>
                  <div
                    id="jumpToBestaetigung"
                    class="mt-3 text-confirm-head text-primary text-confirm-head-clinius"
                  >
                    {{ $t("fast_geschafft") }}
                  </div>
                </div>
                <div class="row mt-5 text-confirm">
                  <div class="col-md-8 offset-md-2">
                    <p>{{ $t('bestaetigung_wunschtermin') }}</p>
                    <p><strong>{{ time | dateLong }} &bull; {{ time | clock }} {{ $t("uhr") }}</strong></p>
                  </div>
                </div>
                <div class="row mt-2 text-confirm">
                  <div class="col-md-8 offset-md-2">
                    <p
                      v-html="$t('bestaetigung_versendet_1', { countdown })"
                    />
                  </div>
                  <div class="col-md-8 offset-md-2">
                    <p
                      v-html="$t('bestaetigung_versendet_2')"
                    />
                  </div>
                  <div class="col-md-8 offset-md-2">
                    <p
                      v-html="$t('bestaetigung_versendet_3')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';

// @ is an alias to /src
//import Start from "@/components/Start.vue";


export default {
  name: "TerminbestaetigungComponent",
  components: {
  },
  data() {
    return {
      validTo: DateTime.now().plus({ minutes: 60 }),
      countdown: '59:59',
      countdownInterval: null,
    };
  },
  computed: {
    proposal() {
      return this.$store.state.termin.selectedTermin;
    },
    time() {
      if (!this.proposal.start) return null;
      return DateTime.fromISO(this.proposal.start).toJSDate();
    },
  },
  async mounted(){
    if (this.isMobile) {
      const el = document.getElementById("jumpToBestaetigung");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    this.countdownInterval = setInterval(() => {
      if (!this.$store.state.bookedAt) return;
      this.countdown = this.$store.state.bookedAt.plus({ minutes: 60 }).diffNow('minutes').toFormat('mm:ss');
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.countdownInterval);
  }
};
</script>
